import tippy from 'tippy.js';

export function initializeImagePreview(element) {
    element.querySelectorAll('[data-image-preview]').forEach(el => {
        if (el._tippy) {
            return;
        }

        const img = document.createElement('img');
        img.src = el.dataset.imagePreview;
        img.className = 'image-preview';

        tippy(el, {
            content: img,
            placement: 'top',
            arrow: true,
        });
    });
}
